module.exports = __webpack_public_path__ + "img/UPAY 行销方案支持增加品牌曝光率@2x.ffc2e843.png";